<div id="header" class="header">
    <a id="header-left" class="header-left" href="/">PAPER View</a>
    <a id="header-right" class="header-right" href="/">Hello, {{userName}}! <small>({{role}})</small></a>
</div>
<br>
<p-tabMenu
        [model]="items"
        [activeItem]="{}"
></p-tabMenu>
